const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1240,
    xl: 1536,
  },
};

export default breakpoints;
